
const layoutConfig = {
    maxColumns: 24,
    sections: [
        // Row 1
        {
            id: "active-members",
            type: "component",
            component: "BhimaStatCard",
            width: 6,
            props: {
                title: "Active Scheme Members",
                // value: "244499",
                // apiParams: { chartid: 5, dashboard_id: 5 },
                apiParams: { dashboard_id: 34, chartid: 37 },
                valuePath: 'active_scheme_members'
            }
        },
        {
            id: "active-folios",
            type: "component",
            component: "BhimaStatCard",
            width: 6,
            props: {
                title: "Active Scheme Folios",
                value: "",
                // apiParams: { chartid: 6, dashboard_id: 6 },
                apiParams: { dashboard_id: 32, chartid: 35 },
                // value: '50521',
                valuePath: 'active_scheme_folios'
            }
        },
        {
            id: "new-enrollments",
            type: "component",
            component: "BhimaStatCard",
            width: 6,
            props: {
                title: "New Scheme Enrollments",
                value: "",
                // apiParams: { chartid: 8, dashboard_id: 8 },
                apiParams: { dashboard_id: 25, chartid: 28 },
                // value: '2404',
                valuePath: 'new_scheme_enrollments'
            }
        },
        {
            id: "maturing-value",
            type: "component",
            component: "BhimaStatCard",
            width: 6,
            props: {
                title: "Scheme Value Maturing in Next 30 Days",
                value: "",
                // apiParams: { chartid: 9, dashboard_id: 9 },
                apiParams: { dashboard_id: 30, chartid: 33 },
                // value: '3510652',
                valuePath: 'scheme_value_maturing_in_next_30_days'
            }
        },

        // Row 2
        {
            id: "collected-commitments",
            type: "component",
            component: "BhimaStatCard",
            width: 6,
            props: {
                // apiParams: { chartid: 10, dashboard_id: 10 },
                apiParams: { dashboard_id: 27, chartid: 30 },
                title: "Collected Active Scheme Commitments",
                value: "184202827",
                valuePath: 'collected_active_scheme_commitments'
            }
        },
        // for now we will ignore this chart
         {
            id: "uncollected-chart",
            type: "component",
            component: "BhimaDonutTotalChart",
            width: 12,
            props: {
                title: "Uncollected Active Scheme Commitments",
                apiParams: { dashboard_id: 19, chartid: 19 },
                valuePath: 'uncollected_active_scheme_commitments'
            }
        },
       
        {
            id: "future-inflows",
            type: "component",
            component: "BhimaStatCard",
            width: 6,
            props: {
                title: "Future cash inflows from active schemes",
                value: "",
                // apiParams: { chartid: 11, dashboard_id: 11 },
                apiParams: { dashboard_id: 28, chartid: 31 },
                // value: '9859341500',
                valuePath: 'future_cash_inflows_from_active_schemes'
            }
        },

        // Row 3
        {
            id: "matured-unredeemed",
            type: "component",
            component: "BhimaStatCard",
            width: 6,
            props: {
                title: "Matured but Unredeemed Scheme Value",
                value: "",
                // apiParams: { chartid: 12, dashboard_id: 12 },
                apiParams: { dashboard_id: 29, chartid: 32 },
                // value: '36252587',
                valuePath: 'matured_but_unredeemed_scheme_value'
            }
        },
        // for now we will ignore this chart
        {
            id: "overdue-chart",
            type: "component",
            component: "BhimaChart",
            width: 12,
            props: {
                title: "Number of Schemes Sold for AGR Branch",
                chartType: "bar",
                apiParams: { dashboard_id: 14, chartid: 14 },
                valuePath: 'number_of_schemes_sold_for_agr_branch',
                // value: '1254'
            }
        },
         {
            id: "overdue-active",
            type: "component",
            component: "BhimaStatCard",
            width: 6,
            props: {
                title: "Overdue Active Scheme Commitments",
                // value: "₹2Cr",
                subtext: "",
                valuePath: 'overdue_active_scheme_commitments',
                apiParams: { dashboard_id: 31, chartid: 34 },
                // value: '84191426'
            }
        },
        // for now we will ignore this chart
        {
            id: "schemes-held",
            type: "component",
            component: "BhimaChart",
            width: 24,
            props: {
                title: "Number of Schemes Held by Each Customer",
                chartType: "line",
                apiParams: { dashboard_id: 22, chartid: 22 },
                valuePath: 'number_of_schemes_held_by_each_customer'
            }
        },
       
    ]
};

export default layoutConfig;
